
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";
import { useEffect, useState } from "react";
import MDButton from "common/components/MD/MDButton";
import AuthService from "services/API/Auth/AuthService";
import CardGiftcardRoundedIcon from '@mui/icons-material/CardGiftcardRounded';
import LocalAtmRoundedIcon from '@mui/icons-material/LocalAtmRounded';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';


function InvitiCard({  percentage, aggiungi_invito,num,num_disponibili,tipo }) {

  ///////////////////////////////////////////////////////////
  const gift = (<CardGiftcardRoundedIcon />);
  const riduzione = (<LocalAtmRoundedIcon />);
  const espo=(<EngineeringRoundedIcon />);

let color=(tipo==="IO"?"primary":(tipo==="IR"?"info":(tipo==="PE"?"warning":"success")));
let icon=(tipo === "IO"?gift:(tipo==="IR") ?riduzione:(tipo==="PE"?espo:null));
let title=(tipo==="IO"?"Biglietti Omaggio":(tipo === "IR"?"Biglietti Ridotti":(tipo==="PE"?"Pass Espositore":"")));
    return (
        <Card>
            <MDBox display="flex" justifyContent="space-between" pt={0} px={2}>
                <MDBox
                    variant="gradient"
                    bgColor={color}
                    color={color === "light" ? "dark" : "white"}
                    coloredShadow={color}
                    borderRadius="xl"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="4rem"
                    height="4rem"
                    mt={-3}
                >
                    <Icon fontSize="medium" color="inherit">
                        {icon}
                    </Icon>
                </MDBox>
                <MDBox textAlign="right" lineHeight={1.25}>
                    <MDTypography variant="button" fontWeight="bold" color="text">
                        {title}
                    </MDTypography>
                    <MDTypography variant="h4">{num} </MDTypography>
                       <MDTypography variant="button" fontWeight="bold" color="text">
                       disponibili
                    </MDTypography>
                </MDBox>
            </MDBox>
            <Divider />
            <MDBox pb={2} px={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '2fr 1fr' }}>

                <MDTypography component="p" variant="button" color="text" display="flex">

                    <MDTypography
                        component="span"
                        variant="button"
                        fontWeight="bold"
                        color={color}
                    >
                        {num_disponibili}
                    </MDTypography>
                    &nbsp;{percentage.label}
                </MDTypography>
                <MDButton variant="contained" color={color} size="small" onClick={()=>aggiungi_invito(tipo)} 
                 disabled={((num_disponibili)<=0 && !AuthService.isAdmin())?true:false}  > <Icon>add</Icon>&nbsp;Inserisci&nbsp;</MDButton>
            </MDBox>
        </Card>
    );
}

// Setting default values for the props of ComplexStatisticsCard
InvitiCard.defaultProps = {
    color: "info",
    percentage: {
        color: "success",
        text: "",
        label: "",
    },

};

// Typechecking props for the ComplexStatisticsCard
InvitiCard.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ]),
 
  
    percentage: PropTypes.shape({
        color: PropTypes.oneOf([
            "primary",
            "secondary",
            "info",
            "success",
            "warning",
            "error",
            "dark",
            "white",
        ]),
        amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
    }),

    aggiungi_invito:PropTypes.func,
};

export default InvitiCard;
